module.exports = __webpack_public_path__ + "static/img/28.e32eae38.png";